
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['query', 'kind', 'preview', 'previewName', 'previewMeta', 'previewMother', 'previewUnderAge', 'submitButton']

  connect() {
    this.format()
  }

  format() {
    if (this.kindTarget.value === 'cpf') {
      this.formatCpf()
    } else if (this.kindTarget.value === 'phone_number') {
      this.formatPhoneNumber()
    }
  }

  preview() {
    const digits = this.queryTarget.value.replace(/\D/g, '')
    if (digits.length !== 11) {
      this.hidePreview()
      return
    }
    clearTimeout(this.previewTimeout)
    this.previewTimeout = setTimeout(() => this.fetchPreview(digits), 300)
  }

  async fetchPreview(cpf) {
    let data
    try {
      const response = await fetch(`/anonymous_searches/preview?cpf=${cpf}`)
      if (!response.ok) return
      data = await response.json()
    } catch {
      // silently fail — preview is optional
      return
    }
    this.renderPreview(data)
  }

  renderPreview(data) {
    if (data.censored) {
      if (this.hasPreviewTarget) this.previewTarget.classList.add('hidden')
      if (this.hasPreviewUnderAgeTarget) this.previewUnderAgeTarget.classList.remove('hidden')
      if (this.hasSubmitButtonTarget) this.submitButtonTarget.disabled = true
      return
    }

    if (this.hasPreviewUnderAgeTarget) this.previewUnderAgeTarget.classList.add('hidden')
    if (this.hasSubmitButtonTarget) this.submitButtonTarget.disabled = false

    if (!data.found || !this.hasPreviewTarget) return

    this.previewNameTarget.textContent = data.name || ''

    const metaParts = []
    if (data.age) metaParts.push(`${data.age} anos`)
    if (data.gender === 'male') metaParts.push('Masculino')
    else if (data.gender === 'female') metaParts.push('Feminino')
    this.previewMetaTarget.textContent = metaParts.join(' · ')

    if (this.hasPreviewMotherTarget && data.mother_name) {
      this.previewMotherTarget.textContent = data.mother_name
    }

    this.previewTarget.classList.remove('hidden')
  }

  hidePreview() {
    if (this.hasPreviewTarget) this.previewTarget.classList.add('hidden')
    if (this.hasPreviewUnderAgeTarget) this.previewUnderAgeTarget.classList.add('hidden')
    if (this.hasSubmitButtonTarget) this.submitButtonTarget.disabled = false
  }

  formatCpf() {
    let value = this.queryTarget.value.replace(/\D/g, "")
    value = value.replace(/(\d{3})(\d)/, "$1.$2")
    value = value.replace(/(\d{3})(\d)/, "$1.$2")
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    this.queryTarget.value = value
  }

  formatPhoneNumber() {
    let value = this.queryTarget.value.replace(/\D/g, "")
    value = value.replace(/(\d{2})(\d)/, "($1) $2")
    value = value.replace(/(\d{4,5})(\d{4})$/, "$1-$2")
    this.queryTarget.value = value
  }
}
